import getEnvVar from '@/utils/getEnvVar';
import { useTranslation } from 'react-i18next';

const useProductVersion = (): string => {
  const { t } = useTranslation();
  return getEnvVar('VITE_APP_VERSION') || t('global.version.unknown');
};

export default useProductVersion;
